/** Accept serialized WhatsApp BODY text, never HTML or visible variable names. */
export function normalizeTemplateBody(body) {
  return typeof body === "string" ? body.replace(/\r\n?/g, "\n").trim() : "";
}

export function validateTemplateBody(body) {
  const normalized = normalizeTemplateBody(body);
  const rules = [
    [!normalized, "required", "El cuerpo del mensaje es requerido"],
    [
      normalized.length < 10,
      "min",
      "El cuerpo del mensaje debe tener al menos 10 caracteres",
    ],
    [
      normalized.length > 1024,
      "max",
      "El cuerpo del mensaje debe tener menos de 1024 caracteres",
    ],
    [
      /\n{3,}/.test(normalized),
      "line-breaks",
      "El mensaje no puede tener más de 2 saltos de línea consecutivos",
    ],
    [
      /^\{\{\d+\}\}/.test(normalized),
      "start-variable",
      "El mensaje no puede iniciar con una variable",
    ],
    [
      /\{\{\d+\}\}$/.test(normalized),
      "end-variable",
      "El mensaje no puede terminar con una variable",
    ],
  ];
  const failure = rules.find(([invalid]) => invalid);
  return {
    valid: !failure,
    normalized,
    code: failure ? failure[1] : null,
    message: failure ? failure[2] : "",
  };
}
